import request from "utils/request";

import { baseRequestURL } from "api/BaseAPI";

export function getModelGroups() {
  return request(baseRequestURL + "v1/modelgroups/", {
    method: "GET"
  }).then((response) => response);
}

export function createModelGroup(jobId, model) {
  return request(baseRequestURL + "v1/modelgroups", {
    method: "POST",
    body: JSON.stringify({
      job_id: Number(jobId),
      model_name: model
    })
  });
}

export function patchModelGroup(id, modelGroup) {
  return request(baseRequestURL + "v1/modelgroup/" + id, {
    method: "PATCH",
    body: JSON.stringify(modelGroup)
  }).then((response) => response);
}

export function deleteModelGroup(id, modelGroup) {
  return request(baseRequestURL + "v1/modelgroup/" + id, {
    method: "DELETE"
  }).then((response) => response);
}

export function deployModelGroup(id, modelgroup = {}) {
  return request(baseRequestURL + "v1/modelgroup/" + id + "/deploy", {
    method: "POST",
    body: JSON.stringify(modelgroup)
  }).then((response) => response);
}
